import {
  createFileRoute,
  lazyRouteComponent,
  redirect,
} from '@tanstack/react-router';

export const Route = createFileRoute(
  '/(client)/my-components/(pages)/(list)/component-skus',
)({
  beforeLoad: ({ location }) => {
    if (
      location.pathname === '/my-components/component-skus' ||
      location.pathname === '/my-components/component-skus/'
    ) {
      throw redirect({ to: '/my-components/component-skus/active' });
    }
  },
  component: lazyRouteComponent(
    () => import('../../../-components/ComponentSkusLayout'),
    'ComponentSkusLayout',
  ),
});
